import React from 'react';
import { HomeNavigation } from './home/HomeNavigation';
import { HomeHero } from './home/HomeHero';
import { ProgramsSection } from './home/ProgramsSection';
import { BenefitsSection } from './home/BenefitsSection';
import { ChallengesSection } from './home/ChallengesSection';
import { HomeProofSection } from './home/HomeProofSection';
import { HomeTrialOffer } from './home/HomeTrialOffer';
import { HomeFooter } from './home/HomeFooter';
export function HomePage() {
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-644">
      <HomeNavigation data-id="element-645" />
      <HomeHero data-id="element-646" />
      <ProgramsSection data-id="element-647" />
      <BenefitsSection data-id="element-648" />
      <ChallengesSection data-id="element-649" />
      <HomeProofSection data-id="element-650" />
      <HomeTrialOffer data-id="element-651" />
      <HomeFooter data-id="element-652" />
    </div>;
}